import { useState, useEffect } from 'react';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { FileText, Scissors } from 'lucide-react';
import { API } from './utils';

export default function OrderPoolTab() {
  const [orders, setOrders] = useState([]);

  const load = () => {
    api.get('/admin/orders?limit=100').then(r => {
      const all = r.data.data?.orders || [];
      setOrders(all.filter(o => o.status === 'APPROVED'));
    }).catch(()=>{});
  };
  useEffect(load, []);

  const startProd = async (id) => {
    try {
      await api.put(`/admin/orders/${id}/status`, { status: 'IN_PRODUCTION', sub_status: 'CUTTING' });
      toast.success('Production started');
      load();
    } catch(e) { toast.error(e.response?.data?.error || 'Failed'); }
  };

  return (
    <div data-testid="order-pool-tab">
      <h2 className="text-lg font-semibold mb-4">Approved Orders — Ready for Production</h2>
      {orders.length === 0 && <p className="text-sm text-muted-foreground">No approved orders waiting.</p>}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {orders.map(o => (
          <div key={o.id} className="border rounded-xl p-4" data-testid={`pool-order-${o.id}`}>
            <p className="text-sm font-bold">{o.order_number}</p>
            <p className="text-xs text-muted-foreground">{o.customer_name} &middot; {o.category_name}</p>
            {o.pdf_url && (
              <a href={`${API}${o.pdf_url}`} target="_blank" rel="noopener noreferrer" className="text-[10px] text-primary hover:underline flex items-center gap-1 mt-1">
                <FileText className="w-3 h-3" /> PDF
              </a>
            )}
            <Button size="sm" className="w-full mt-3 text-xs h-8 gap-1" onClick={() => startProd(o.id)} data-testid={`start-prod-${o.id}`}>
              <Scissors className="w-3.5 h-3.5" /> Start Production
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
